var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',{staticClass:"mt-2 p-2"},[_c('b-col',{attrs:{"cols":"12"}},[_c('service-section',{attrs:{"editable":true}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }